import { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@jana-technology/platform-ui";

import { LoadingSpinner } from "components/loaders";
import { useOutcomeScenariosContext } from "contexts/scenarios";
import { SidebarSpacer, SidebarComponentHeading } from "components/sidebar";

export const OutcomeScenariosSelect = () => {
  const params = useParams<{ failureModeEffect: string }>();

  const decodedFailureModeParam = decodeURIComponent(
    params?.failureModeEffect ?? "",
  );

  const {
    loading,
    scenarios,
    selectedScenario: appliedScenario,
    savedSelectedScenario: pendingScenario,
    setSavedSelectedScenario: setPendingScenario,
    onScenarioSelect,
    syncScenarioFromRoute,
  } = useOutcomeScenariosContext();

  // initialize from route/default without clobbering staged user selection
  useEffect(() => {
    if (!scenarios.length) {
      return;
    }

    const routeValue = decodedFailureModeParam;
    const hasValidRouteValue =
      Boolean(routeValue) &&
      scenarios.some((scenario) => scenario.value === routeValue);
    const hasPendingSelection =
      Boolean(pendingScenario) && pendingScenario !== appliedScenario;

    if (
      hasValidRouteValue &&
      routeValue !== appliedScenario &&
      !hasPendingSelection
    ) {
      syncScenarioFromRoute(routeValue);

      return;
    }

    if (!appliedScenario) {
      onScenarioSelect(scenarios[0].value);

      return;
    }

    if (!pendingScenario) {
      setPendingScenario(appliedScenario);
    }
  }, [
    decodedFailureModeParam,
    onScenarioSelect,
    pendingScenario,
    scenarios,
    appliedScenario,
    setPendingScenario,
    syncScenarioFromRoute,
  ]);

  return (
    <LoadingSpinner loading={loading} className="h-10">
      <SidebarSpacer>
        <SidebarComponentHeading>Outcome Scenario:</SidebarComponentHeading>
        {Boolean(pendingScenario ?? appliedScenario) && (
          <Select
            value={pendingScenario ?? appliedScenario}
            onValueChange={setPendingScenario}
          >
            <SelectTrigger className="w-full" id="outcome-scenario-select">
              <SelectValue placeholder="Select one" />
            </SelectTrigger>
            <SelectContent>
              {scenarios.map((scenario) => (
                <SelectItem key={scenario.value} value={scenario.value}>
                  {scenario.children}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
      </SidebarSpacer>
    </LoadingSpinner>
  );
};

export default OutcomeScenariosSelect;
